import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./EventsPage.css";
import { FaArrowLeft, FaTrashAlt, FaDownload, FaEdit } from 'react-icons/fa';
import config from '../config/config';

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // Fetching the API URL from configuration
  const apiUrl = `${config.API_URL}/api`;

  useEffect(() => {
    const fetchEvents = async () => {
      try {

        const response = await axios.get(`${apiUrl}/events`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        ;
        setEvents(response.data);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, [apiUrl, token]);

  // Filter events based on search query
  const filteredEvents = events.filter((event) => {
    const searchLower = searchQuery.toLowerCase();
    const nameMatch = event.name?.toLowerCase().includes(searchLower);
    const phoneMatch = event.contract?.clientTel && String(event.contract.clientTel).includes(searchLower);
    const p1Match = event.phone1 && event.phone1.includes(searchLower);
    const p2Match = event.phone2 && event.phone2.includes(searchLower);
    const p3Match = event.phone3 && event.phone3.includes(searchLower);
    return nameMatch || phoneMatch || p1Match || p2Match || p3Match;
  });

  // Sort events by date
  const sortedEvents = [...filteredEvents].sort((a, b) => {
    return sortOrder === "asc"
      ? new Date(a.date) - new Date(b.date)
      : new Date(b.date) - new Date(a.date);
  });

  // Cancel or reactivate the event
  const handleEventStatus = async (eventId, status) => {
    const confirmationMessage =
      status === "Cancelled"
        ? "Voulez-vous vraiment réactiver cet événement ?"
        : "Voulez-vous vraiment annuler cet événement ?";
    const userConfirmed = window.confirm(confirmationMessage);

    if (userConfirmed) {
      try {
        await axios.put(`${apiUrl}/events/${eventId}/cancel`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        ;
        const response = await axios.get(`${apiUrl}/events`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        ;
        setEvents(response.data);
      } catch (error) {
        console.error("Error updating event status:", error);
      }
    }
  };

  // Delete an event
  const handleDeleteEvent = async (eventId) => {
    const userConfirmed = window.confirm(
      "Êtes-vous sûr de vouloir supprimer cet événement ?"
    );

    if (userConfirmed) {
      try {
        await axios.delete(`${apiUrl}/events/${eventId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        ; // Updated link
        const response = await axios.get(`${apiUrl}/events`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        ; // Updated link
        setEvents(response.data);
      } catch (error) {
        console.error("Error deleting event:", error);
      }
    }
  };

  // Function to download the contract
  const downloadContract = (contractId, clientName) => {
    const sanitizedClientName = clientName.replace(/ /g, "_");  // Replace spaces with underscores
    const url = `${config.API_URL}/uploads/contracts/${sanitizedClientName}_${contractId}.docx`;
    window.open(url, "_blank");
  };

  const navigateToDetails = (eventId) => {
    navigate(`/events/${eventId}`);
  };

  return (
    <div className="events-container">
      {/* Back Button */}
      <button
        type="button"
        className="back-button"
        onClick={() => navigate('/')}
      >
        <FaArrowLeft className="back-icon" />
        Retour
      </button>

      {/* Page Header */}
      <div className="events-page-header">
        <div className="header-content">
          <h1>Liste des Événements</h1>
          <p className="events-subtitle">
            Gérez tous vos événements et contrats
          </p>
        </div>
        <div className="header-actions">
          <button className="add-button" onClick={() => navigate("/add-event")}>
            Ajouter un événement
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="filters">
        <input
          type="text"
          placeholder="Rechercher un événement..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <select onChange={(e) => setSortOrder(e.target.value)}>
          <option value="asc">Trier par date (croissant)</option>
          <option value="desc">Trier par date (décroissant)</option>
        </select>
      </div>

      {/* Events List */}
      <div className="events-list">
        {sortedEvents.length > 0 ? (
          sortedEvents.map((event) => (
            <div key={event.id} className="event-card">
              <div className="event-card-header">
                <h3>{event.name}</h3>
                <p><strong>Date:</strong> {new Date(event.date).toLocaleDateString()}</p>
                <p><strong>Lieu:</strong> {event.location}</p>
                <p>
                  <strong>Status:</strong>
                  <span className={`status-badge ${event.status === 'cancelled' ? 'status-cancelled' : 'status-active'}`}>
                    {event.status === 'cancelled' ? 'Annulé' : 'Actif'}
                  </span>
                </p>
              </div>

              <div className="event-card-actions">
                <button
                  className="edit-button"
                  onClick={() => navigate(`/edit-event/${event.id}`)}
                  title="Modifier"
                >
                  <FaEdit />
                </button>

                {event.contractId && (
                  <button
                    className="download-button"
                    onClick={() => downloadContract(event.contractId, event.name)}
                    title="Télécharger le contrat"
                  >
                    <FaDownload />
                  </button>
                )}

                <button
                  className="delete-button"
                  onClick={() => handleDeleteEvent(event.id)}
                  title="Supprimer"
                >
                  <FaTrashAlt />
                </button>
              </div>

              <button
                className="details-toggle-btn"
                onClick={() => navigateToDetails(event.id)}
              >
                Voir les détails
              </button>
            </div>
          ))
        ) : (
          <p>Aucun événement trouvé.</p>
        )}
      </div>
    </div>
  );
};

export default EventsPage;
